<div class="footer-container" />

<style>
  .footer-container {
    height: 10em;
  }
</style>
